
  import { defineComponent, PropType } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import { downloadPDF } from '@/common/utils/fileExport';

  import { TDashboardCountryFilter } from '@/modules/ves/types/countryDashboards';
  import { moveDashboardsChartsToTopLevel } from '@/modules/ves/utils/dashboardsCharts';

  import apiDashboards from '../../../api/dashboardsVES';
  import DashboardsCardFilterBlock from '../dashboards-card-filter-block/DashboardsCardFilterBlock.vue';
  import { TSelectConfig } from '../dashboards-card-filter-block/types';

  import { DIRECTIVES_ACTIONS_NAME, DIRECTIVES_GETTERS_NAME } from '@/store/directives';

  export default defineComponent({
    name: 'CountryDashboardsFilterBlock',
    components: {
      DashboardsCardFilterBlock,
    },
    emits: {
      changeFilter: (value: TDashboardCountryFilter) => value,
      downloadPDF: () => true,
    },
    props: {
      plannedEventsRegionRfIds: {
        type: Array as PropType<number[]>,
        default: () => [],
      },
      filter: {
        type: Object as PropType<TDashboardCountryFilter>,
        required: true,
      },
    },
    data(): { isExportProgress: boolean } {
      return {
        isExportProgress: false,
      };
    },
    created() {
      this.getPartnerCountrySearchId();
    },
    computed: {
      ...mapGetters({
        partnerCountryList: DIRECTIVES_GETTERS_NAME.getPartnerCountrySearchIdList,
      }),
      getSelectConfig(): TSelectConfig<TDashboardCountryFilter> {
        return {
          filterKey: 'countryId',
          options: this.getCountryOptions,
          title: 'Карточка страны',
        };
      },
      getCountryOptions() {
        return this.partnerCountryList.map((i: { id: number; name: string }) => ({ value: i.id, label: i.name }));
      },
    },
    methods: {
      ...mapActions({
        getPartnerCountrySearchId: DIRECTIVES_ACTIONS_NAME.getPartnerCountrySearchId,
      }),
      changeFilter(filter: TDashboardCountryFilter) {
        this.$emit('changeFilter', filter);
      },
      async downloadPDF() {
        this.isExportProgress = true;
        try {
          await downloadPDF({
            clonedElementClassName: 'country-dashboards-ves__export-pdf',
            pagebreakMode: 'table-friendly',
            fileName: 'Мониторинг_реализации_документов_по_ВЭС',
            clonedNodeFormatter: moveDashboardsChartsToTopLevel,
          });
        } finally {
          this.isExportProgress = false;
        }
      },
      async downloadPptx() {
        this.isExportProgress = true;
        try {
          await apiDashboards.exportPptx('exportcountry', {
            ...this.filter,
            regionRfIds: this.plannedEventsRegionRfIds,
          });
        } finally {
          this.isExportProgress = false;
        }
      },
    },
  });
